module.exports = __webpack_public_path__ + "img/central-african-republic.e5bac49e.png";